export const WhatsAppSignup = () => {
  return <div className="text-white">WhatsApp Signup Component</div>;
};
